module.exports = __webpack_public_path__ + "adc86e72fe398effa2369deb0409f676.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-10.png
// module id = 2103
// module chunks = 0